import {atom, selector} from 'recoil';

import {LEAGUE_CONFIGURATIONS} from '@chancer/common/lib/interfaces/firestore/LeaguesEnums';

export const currentLeagueIdState = atom<string | null>({
  key: 'currentLeagueIdState',
  default: null,
});

export const currentMatchIdState = atom<string | null>({
  key: 'currentMatchIdState',
  default: null,
});

export const currentLeagueState = selector({
  key: 'currentLeagueState',
  get: ({get}) => {
    const currentLeagueId = get(currentLeagueIdState);
    return LEAGUE_CONFIGURATIONS.find((c) => c.id === currentLeagueId) ?? null;
  },
});
